import fetchClient from '../utils/fetchClient';
import { useQuery } from 'react-query';
import { useQueryClient } from 'react-query';

export const getAllCollections = () => fetchClient.get('/collections/');
export const getCollectionsByUserId = (userId) => fetchClient.get(`/collections/?user_id=${userId}`);
export const getCollectionById = (collection_id) => fetchClient.get(`/collections/${collection_id}`);
export const getCollectionPostcards = (collection_id, language = null) => {
    const params = new URLSearchParams();
    if (language && language !== 'all') {
        params.append('language', language);
    }
    const queryString = params.toString();
    return fetchClient.get(`/collections/${collection_id}/postcards${queryString ? `?${queryString}` : ''}`);
};
export const getCollectionSandboxPostcards = (collectionId) => {
	return fetchClient.get(`/collections/${collectionId}/sandbox`);
};
export const createCollection = (data) => fetchClient.post('/collections/', data);
export const updateCollection = (collection_id, data) => fetchClient.put(`/collections/${collection_id}`, data);
export const updateCollectionLanguage = (collection_id, language) => fetchClient.put(`/collections/${collection_id}`, { language });
export const getCollectionCategoriesGrouped = (collection_id, { includeAll = false } = {}) =>
    fetchClient.get(`/collections/${collection_id}/categories_grouped${includeAll ? '?include_all=true' : ''}`);

export const deleteCollection = (collection_id) => fetchClient.delete(`/collections/${collection_id}`);
export const subscribeToCollection = (collection_id, subscriber_id) => fetchClient.post(`/collections/${collection_id}/subscribe`, { subscriber_id });
export const unsubscribeFromCollection = (collection_id, subscriber_id) => fetchClient.delete(`/collections/${collection_id}/subscribe?subscriber_id=${subscriber_id}`);
export const getCollectionSubscribers = (collection_id) => fetchClient.get(`/collections/${collection_id}/subscribers`);
export const getCollectionSubscriptions = (user_id) => fetchClient.get(`/collections/subscriptions/?user_id=${user_id}`);

export const useCollectionsByUserId = (userId) => {
    return useQuery(
        ['collections', userId],
        () => getCollectionsByUserId(userId),
        {
            staleTime: 1000 * 60 * 5, // 5 минут
            cacheTime: 1000 * 60 * 10, // 10 минут
            enabled: !!userId, // Запрос выполняется только если есть userId
            onSuccess: (data) => {

            },
        }
    );
};
